//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { IApiConfig } from '@4r/module-common-mf-app';
export class AuthorizedApiClient {
  private readonly config: IApiConfig;

  protected constructor(config: IApiConfig) {
    this.config = config;
  }

  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    options.headers = {
      ...options.headers,
      Authorization: this.config.getAuthorization(),
    };
    return Promise.resolve(options);
  };
}

export class AttendanceClient extends AuthorizedApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://g9-oculos.westus.cloudapp.azure.com/mf-time-attendance-api";
    }

    currentEmployee(): Promise<CurrentEmployeeModel> {
        let url_ = this.baseUrl + "/api/Attendance/CurrentEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCurrentEmployee(_response);
        });
    }

    protected processCurrentEmployee(response: Response): Promise<CurrentEmployeeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentEmployeeModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentEmployeeModel>(null as any);
    }

    clockIn(command: ClockInCommand): Promise<AttendanceCommandResult> {
        let url_ = this.baseUrl + "/api/Attendance/ClockIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClockIn(_response);
        });
    }

    protected processClockIn(response: Response): Promise<AttendanceCommandResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttendanceCommandResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttendanceCommandResult>(null as any);
    }

    clockOut(command: ClockOutCommand): Promise<AttendanceCommandResult> {
        let url_ = this.baseUrl + "/api/Attendance/ClockOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClockOut(_response);
        });
    }

    protected processClockOut(response: Response): Promise<AttendanceCommandResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttendanceCommandResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttendanceCommandResult>(null as any);
    }
}

export interface IdModel {
    id: string;
}

export interface CurrentEmployeeModel extends IdModel {
    isTimeEntryRequired: boolean;
    lastEvent?: AttendanceEventDto | undefined;
    possibleActions: AttendanceActionDto[];
    events: AttendanceEventDto[];
}

export interface AttendanceEventDto {
    id?: string;
    timestamp?: string;
    typeId?: string;
    typeName?: string | undefined;
    statusName?: string | undefined;
    isConfirmed?: boolean;
}

export interface AttendanceActionDto {
    typeId: string;
    typeName: string;
    statusName: string;
    isClockIn: boolean;
    previousActionTypeIds: string[];
}

export interface AttendanceCommandResult {
    id?: string;
}

export interface AttendanceCommand {
    id?: string | undefined;
    eventTimestamp?: string | undefined;
    typeId?: string;
}

export interface ClockInCommand extends AttendanceCommand {
}

export interface ClockOutCommand extends AttendanceCommand {
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

// eslint-disable-next-line max-classes-per-file